module.exports = __webpack_public_path__ + "static/img/SEFoundation_training_8079.3dca1fc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/outreach/SEFoundation_training_8079.jpg
// module id = uTMI
// module chunks = 0